/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/VideoBaseContent/theme';

export const VideoBaseContentTheme = theme;
